import homologConfig from './homolog.config'
import { buildViuRegionsFromEnv, buildViuCarrierAsnMapFromEnv } from './viuRegionsFromEnv'

export default Object.assign(homologConfig, {
  environment: 'prod',
  applicationKey: 'cd323b3c-da73-4b18-8d66-688002cd9184',
  applicationSecret: 'jLYlcjYWZBWCAnCn6jiAblFd',
  sabBaseUrl: 'https://pkp-prod.sandboxkids.io',
  vindiBaseUrl: 'https://app.vindi.com.br',
  vindiApiSecret: '2o-JHJ2w6zasKfTUjjV839EyiK6pJWdvK-5Eu-ilu-g',
  appsBuilderBaseUrl: 'https://appsbuilder.sandboxkids.io',
  contentTreeBaseUrl: 'https://cdn.playkidsapp.com/playkids_web',
  peanutbutterBaseUrl: 'https://peanutbutter.playkids.com',
  brazeApiKey: 'a476e4d9-ed3a-4a8a-817e-8de8e6e2c62e',
  integrationACL: {
    baseUrl: 'https://playhub.sandboxkids.io',
    clientId: '',
    clientSecret: ''
  },
  /**
   * Viu HE — per-region outbound URL; IP must match a configured `countryCode` unless bypass is on.
   */
  viu: {
    enabled: process.env.VUE_APP_VIU_ENABLED === 'true',
    clientRedirect: process.env.VUE_APP_VIU_CLIENT_REDIRECT === 'true',
    aesKey: process.env.VUE_APP_VIU_AES_KEY || '',
    aesIv: process.env.VUE_APP_VIU_AES_IV || '',
    partnerErrorPath: process.env.VUE_APP_VIU_PARTNER_ERROR_PATH || '/header-enrichment/error',
    regions: buildViuRegionsFromEnv(),
    carrierAsnMap: buildViuCarrierAsnMapFromEnv(),
    xApiKey: process.env.VUE_APP_VIU_X_API_KEY || '',
    debugHashOverride: process.env.VUE_APP_VIU_DEBUG_HASH_OVERRIDE || '',
    allowDesktopHeCallback: process.env.VUE_APP_VIU_ALLOW_DESKTOP_HE_CALLBACK === 'true',
    hashDecodeFallbackEnabled: process.env.VUE_APP_VIU_HASH_DECODE_FALLBACK_ENABLED !== 'false',
    /** Kill switch for the missing-MSISDN HE retry — see `retryViuHeForMissingMsisdn`. */
    missingMsisdnRetryEnabled: process.env.VUE_APP_VIU_MISSING_MSISDN_RETRY_ENABLED !== 'false'
  }
})
